import styled from "styled-components";
import { transparentize } from "polished";

const PageVeil = styled.div`
  height: 100vh;
  width: -webkit-fill-available;
  background-color: ${(props) =>
    transparentize(0.2, props?.theme?.colors?.brand4)};
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => `${props?.theme?.space?.[2]}px`};
  z-index: 10;
`;

export default PageVeil;
